module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_video_data":"There are no videos registered.","no_video_reviews":"There are no video reviews."}}')
  delete Component.options._Ctor
}
